const set = (key, value) => localStorage.setItem(key, JSON.stringify({ value }));

const get = key => {
  const str = localStorage.getItem(key);
  if(str && str.length) {
    return JSON.parse(str).value;
  }
};

const remove = key => localStorage.removeItem(key);

module.exports = {
  set,
  get,
  remove
};
